import { http } from '../helpers/axiosHelper';

export default class RoleService {
   async getRoles() {
      return http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/role').then((response) => {
         return response.data;
      });
   }

   async getPermissionRoles() {
      return http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/permission-role').then((response) => {
         return response.data;
      });
   }

   async postPermissionRole(roleId: Number, permissionId: Number) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/permission-role', { role_id: roleId, permission_id: permissionId })
         .then((response) => {
            return response.data;
         });
   }

   async deletePermissionRole(permissionRoleId: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/permission-role/' + permissionRoleId).then((response) => {
         return response.data;
      });
   }
}
